import { type LocaleType, useResource } from '@landsbankinn/l16n';
import {
  ArrowRightIcon24,
  ListItem,
  RichLink,
  UnorderedList,
} from '@landsbankinn/ui-kit';

interface IProps {
  onChange: () => void;
}

function CultureLink(props: {
  locale: LocaleType;
  label: string;
  onClick: (locale: LocaleType) => void;
}) {
  return (
    <ListItem
      key={props.locale}
      id={props.locale}
      onClick={(e: React.MouseEvent<HTMLLIElement>) => {
        e.preventDefault();
        props.onClick(props.locale);
      }}
    >
      <RichLink
        href={`/?culture=${props.locale}`}
        rel="noreferrer"
        instrumentAs="select_language"
        condense
        labelFontSize="26"
        labelFontWeight="medium"
        instrumentData="account"
        endIcon={<ArrowRightIcon24 />}
        label={props.label}
      />
    </ListItem>
  );
}

export function CultureSelector({ onChange }: IProps) {
  const { setLocale } = useResource();
  const handleOnClick = (locale: LocaleType) => {
    if (setLocale) setLocale(locale);
    onChange();
  };
  return (
    <UnorderedList marginBottom="0">
      <CultureLink label="Íslenska" locale="is" onClick={handleOnClick} />
      <CultureLink label="English" locale="en" onClick={handleOnClick} />
      <CultureLink label="Polski" locale="pl" onClick={handleOnClick} />
    </UnorderedList>
  );
}
